import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {mediaMinTablet} from '../../../../../ui/constants/customMedia';
import {ExtendedLiveShoppingSection} from '../../../types';
import {EventHeader} from '../EventHeader/EventHeader';
import {LiveSectionEvents} from './LiveSectionEvents';

export const LiveSection: FC<{section: ExtendedLiveShoppingSection}> = ({
  section,
}) => {
  return (
    <LiveShoppingSection
      key={section.title}
      data-testid={`LiveShoppingSection-${section.state?.$case}`}
      eventsHaveEnded={section.state?.$case === 'ended'}
    >
      <EventHeader title={section.title} subtitle={section.subtitle} />
      <LiveSectionEvents
        events={section.events}
        eventsHaveEnded={section.state?.$case === 'ended'}
      />
    </LiveShoppingSection>
  );
};

const LiveShoppingSection = styled.section<{eventsHaveEnded: boolean}>`
  ${props =>
    props.eventsHaveEnded
      ? css`
          @media ${mediaMinTablet} {
            padding-top: 60px;
          }
        `
      : ''}
`;
